import outsideclick from './outsideclick';
import appendToBody from './appendToBody';
import loading from './loading';
import sticky from './sticky';
import lazy from './lazyLoad';
import error from './error';
import empty from './empty';
import click from './click';
import tip from './tip';
export default Vue => {
    outsideclick(Vue);
    appendToBody(Vue);
    loading(Vue);
    sticky(Vue);
    lazy(Vue);
    error(Vue);
    empty(Vue);
    click(Vue);
    tip(Vue);
};
